import { SNF_API_BASE_URL } from '@constants/environment/environment';
import { SnfIntlHttpRemoteCall } from '../snf-intl.http-remote-call';

export class GetMainCategoriesRemoteCall extends SnfIntlHttpRemoteCall {
  /**
   * @inheritdoc
   */
  relativePath = 'categories/main';

  cache = true;

  /**
   * @inheritdoc
   */
  constructor(language, isServer) {
    super(language);
    if (!isServer) {
      this.baseUrl = `${window.location.origin}${SNF_API_BASE_URL}`;
    }
  }

  getQuery() {
    return {
      ...super.getQuery()
    };
  }
}
